import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import ShortSelfIpoGridItem from './ShortSelfIpoGridItem';

interface Props {
  offerings: SelfIpoOffering[];
  onCardClick: (offeringId: ID) => void;
  itemsCountPerRow?: number;
}

const ShortSelfIpoGrid: FC<Props> = ({
  offerings,
  onCardClick,
  itemsCountPerRow = 3,
}) => {
  const gapBetweenCards = 16;

  return (
    <Flex w="100%">
      {offerings.map((offering, index) => (
        <ShortSelfIpoGridItem
          key={offering.id}
          offering={offering}
          mr={
            (index + 1) % itemsCountPerRow === 0 ? '0' : `${gapBetweenCards}px`
          }
          w={`calc(100% / ${itemsCountPerRow} - ${gapBetweenCards / 2}px)`}
          onClick={() => onCardClick(offering.id)}
        />
      ))}
    </Flex>
  );
};

export default ShortSelfIpoGrid;
